module.exports = __webpack_public_path__ + "img/barricade-white.2f61a1f3.svg";